import { useQuery } from '@tanstack/react-query';

import { useVehicleOptions } from '~/contexts/VehicleOptionsContext';
import { getVehicleImage } from '~/controllers/images';
import { ICamera } from '~/domain/ICamera';
import { IImageSettings } from '~/domain/IImageSettings';
import { CACHE_TIME_2HR, STALE_TIME_2HR } from '~/queryCache';

import { useImageUrl } from './useImageUrl';

interface IUseImage {
  camera: ICamera;
  settings: IImageSettings;
  query?: { enabled?: boolean };
  signal?: boolean | AbortSignal;
  enabled?: boolean;
}

export const useImageQuery = (props: IUseImage) => {
  const { settings, camera, query, signal = true, enabled = true } = props;
  const imageUrl = useImageUrl();
  const vehicleOptions = useVehicleOptions();
  const src = imageUrl(camera, settings);
  return useQuery([src], getVehicleImage, {
    cacheTime: CACHE_TIME_2HR,
    staleTime: STALE_TIME_2HR,
    refetchOnMount: false,
    refetchOnReconnect: false,
    keepPreviousData: true,
    enabled: enabled && !!src && vehicleOptions.features.length > 0,
    meta: {
      signal,
    },
    ...query,
  });
};
